// Semicolon (;) to ensure closing of earlier scripting
    // Encapsulation
    // $ is assigned to jQuery
    ;(function($) {

         // DOM Ready
        $(function() {

            // Binding a click event
            // From jQuery v.1.7.0 use .on() instead of .bind()
            

                // Prevents the default action to be triggered. 
               $('.b-close').click(function(){
                  // Set a cookie

                 
                  
                 var expDate = new Date();

expDate.setTime(expDate.getTime() + (30*24*60*60*1000)); // add 30 Days

$.cookie('country', 'country popup', { path: '/', expires: expDate });
                 
               }); 

          
          
          if (!!$.cookie('country')) {
 // have cookie
            console.log('cookie yes');
} else {
 // no cookie
            console.log('cookie no');

            // Triggering bPopup when click event is fired
            setTimeout(function(){   
            $('#element_to_pop_up').bPopup({
                    modalClose: false
                });
              }, 10000);
            
}
                

          

        });

    })(jQuery);


// scroll to section js
$('.sampling-img-with-text .image-with-text__content a').click(function() {
  $('html, body').animate({
    scrollTop: $(".sampling-desc").offset().top
  }, 1000)
})


// video autoplay js
$(document).ready(function() {
  $('.video-section__media.deferred-media').on('click', function(ev) {
 
    $(".js-youtube")[0].src += "&autoplay=1";
    ev.preventDefault();
 
  });
});